const formatTags = require("../../dict/formatTags.js");
module.exports = function replaceUnderlineTags(text, openTag, closeTag){
    let openPattern = new RegExp(formatTags.underline.open, "gmi"),
        closePattern = new RegExp(formatTags.underline.close, "gmi")
    return text.replace(openPattern,openTag).replace(closePattern, closeTag);
}